import { Link } from 'react-router-dom';
import type { Reservation } from '@/modules/reservations/types';
import { modulePaths } from '@/routes/paths';

type ConflictAlertProps = {
  conflicts: Reservation[];
  ineligibleItems?: Array<{ itemId: string; reason: string }>;
  dateRangeInvalid?: boolean;
};

export function ConflictAlert({
  conflicts,
  ineligibleItems = [],
  dateRangeInvalid,
}: ConflictAlertProps) {
  if (
    !dateRangeInvalid &&
    conflicts.length === 0 &&
    ineligibleItems.length === 0
  ) {
    return null;
  }

  return (
    <div className="reservation-conflicts" role="alert">
      <strong>No se puede confirmar la reserva</strong>
      {dateRangeInvalid ? (
        <p>La fecha de inicio debe ser anterior a la fecha de fin.</p>
      ) : null}
      {ineligibleItems.length > 0 ? (
        <ul>
          {ineligibleItems.map((item) => (
            <li key={item.itemId}>
              Artículo <code>{item.itemId}</code>: {item.reason}
            </li>
          ))}
        </ul>
      ) : null}
      {conflicts.length > 0 ? (
        <>
          <p>Reservas que bloquean el rango seleccionado:</p>
          <ul>
            {conflicts.map((c) => (
              <li key={c.id}>
                <Link to={`${modulePaths.reservations}/${c.id}`}>{c.title}</Link>
                {' '}
                ({c.startDate} → {c.endDate})
              </li>
            ))}
          </ul>
        </>
      ) : null}
    </div>
  );
}
